<script setup>
// Inspector do nó "Áudio da ligação" (FlexCalls). Este nó é declarativo: só
// estar no fluxo já liga a entrega do áudio gravado (Flexcalls::DeliveryPolicy
// checa a PRESENÇA do nó, não um campo dele). Por isso não há nenhum campo
// pra configurar aqui — só a explicação do que acontece.
//
// Existe um método send_audio_to_customer? no backend, mas nada o chama ainda
// nesta fase: o áudio sempre chega como nota interna. Não expor um toggle
// "enviar para o cliente" aqui de propósito — ligá-lo não faria nada e viraria
// ticket de suporte.
import { useI18n } from 'vue-i18n';

defineProps({ data: { type: Object, required: true } });
const emit = defineEmits(['remove', 'close']);
const { t } = useI18n();
</script>

<template>
  <div class="p-4">
    <div class="mb-3 flex items-center justify-between">
      <div class="flex items-center gap-2.5">
        <span
          class="flex size-8 shrink-0 items-center justify-center rounded-xl bg-n-brand/15 text-n-brand"
        >
          <span class="i-lucide-audio-lines text-base" />
        </span>
        <h3 class="text-sm font-semibold text-n-slate-12">
          {{ data.label || t('AI_AGENTS.FLOW.FLEXCALLS.AUDIO_TITLE') }}
        </h3>
      </div>
      <button class="i-lucide-x text-n-slate-10" @click="emit('close')" />
    </div>

    <p class="mb-3 text-xs text-n-slate-10">
      {{ t('AI_AGENTS.FLOW.FLEXCALLS.AUDIO_DESCRIPTION') }}
    </p>

    <div
      class="flex items-start gap-2 rounded-lg border border-n-teal-6 bg-n-teal-2 px-3 py-2 text-xs text-n-teal-11"
    >
      <span class="i-lucide-lock mt-0.5 shrink-0" />
      <span>{{ t('AI_AGENTS.FLOW.FLEXCALLS.AUDIO_NOTE') }}</span>
    </div>

    <button
      class="mt-4 w-full rounded-lg border border-n-ruby-7 py-2 text-sm font-medium text-n-ruby-9 hover:bg-n-ruby-3"
      @click="emit('remove')"
    >
      {{ t('AI_AGENTS.FLOW.REMOVE_NODE') }}
    </button>
  </div>
</template>
